export const DATENSTAND = "24.10.2025";
